import { render, staticRenderFns } from "./PzSdk.vue?vue&type=template&id=04f34484"
import script from "./PzSdk.vue?vue&type=script&lang=js"
export * from "./PzSdk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04f34484')) {
      api.createRecord('04f34484', component.options)
    } else {
      api.reload('04f34484', component.options)
    }
    module.hot.accept("./PzSdk.vue?vue&type=template&id=04f34484", function () {
      api.rerender('04f34484', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/DigitalSings/Fad3/PzSdk.vue"
export default component.exports